import { useEffect, useMemo, useState } from "react";
import CreateFollowUpModal from "../../../components/modals/CreateFollowUpModal";
import { completeFollowUp } from "../../../services/contact_service";

function formatDate(value) {
    if (!value) {
        return "N/A";
    }
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) {
        return value;
    }
    return date.toLocaleDateString();
}

function formatDateTime(value) {
    if (!value) {
        return "N/A";
    }
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) {
        return value;
    }
    return date.toLocaleString();
}

function FollowUpTab({ contactId, followUps, followUpsLoading, followUpsError, onRefreshTabData, panelActionRequest }) {
    const [isCreateOpen, setIsCreateOpen] = useState(false);
    const [actionLoading, setActionLoading] = useState(null);

    useEffect(() => {
        if (panelActionRequest?.type === "Follow-Up") {
            setIsCreateOpen(true);
        }
    }, [panelActionRequest?.nonce]);

    const rows = useMemo(() => {
        return Array.isArray(followUps) ? followUps : [];
    }, [followUps]);

    async function handleCompleteFollowUp(followUpId) {
        setActionLoading(followUpId);
        try {
            await completeFollowUp(followUpId);
            onRefreshTabData?.();
        } catch (err) {
            console.error("Failed to complete follow up:", err);
        } finally {
            setActionLoading(null);
        }
    }

    return (
        <section className="tab-panel-container">
            <header className="tab-panel-header">
                <h3>Follow-Ups</h3>
                <button
                    type="button"
                    className="tab-panel-btn tab-panel-btn--primary"
                    onClick={() => setIsCreateOpen(true)}
                >
                    Create Follow Up +
                </button>
            </header>

            {followUpsLoading ? (
                <p className="contact-detail-tab-empty">Loading follow-ups...</p>
            ) : null}

            {!followUpsLoading && followUpsError ? (
                <p className="contact-detail-tab-empty">{followUpsError}</p>
            ) : null}

            {!followUpsLoading && !followUpsError && rows.length === 0 ? (
                <p className="contact-detail-tab-empty">No Follow-Up data yet.</p>
            ) : null}

            {!followUpsLoading && !followUpsError && rows.length > 0 ? (
                <div className="followup-table-wrap">
                    <table className="tab-panel-table followup-table">
                        <thead>
                            <tr>
                                <th>Status</th>
                                <th>Due Date</th>
                                <th>Method</th>
                                <th>Outcome</th>
                                <th>Next Step</th>
                                <th>User</th>
                                <th>Created At</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {rows.map((item) => (
                                <tr key={String(item.id)}>
                                    <td>
                                        <span className={`followup-status ${item.completed ? "is-complete" : "is-pending"}`}>
                                            {item.completed ? "Complete" : "Pending"}
                                        </span>
                                    </td>
                                    <td>{formatDate(item.follow_up_date)} {item.follow_up_time || ""}</td>
                                    <td>{String(item.method || "N/A").toUpperCase()}</td>
                                    <td>N/A</td>
                                    <td>{item.next_step || "N/A"}</td>
                                    <td>{item.user?.name || "N/A"}</td>
                                    <td>{formatDateTime(item.created_at)}</td>
                                    <td className="followup-actions">
                                        <button
                                            type="button"
                                            className={`action-btn action-btn--small ${item.completed ? "action-btn--undo" : "action-btn--complete"}`}
                                            onClick={() => handleCompleteFollowUp(item.id)}
                                            disabled={actionLoading === item.id}
                                            title={item.completed ? "Mark as pending" : "Mark as complete"}
                                        >
                                            {actionLoading === item.id ? "..." : (item.completed ? "Undo" : "Complete")}
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            ) : null}

            {isCreateOpen && (
                <CreateFollowUpModal
                    isOpen={isCreateOpen}
                    contactId={contactId}
                    onClose={() => setIsCreateOpen(false)}
                    onCreated={() => {
                        onRefreshTabData?.();
                    }}
                />
            )}
        </section>
    );
}

export default FollowUpTab;
